module.exports = __webpack_public_path__ + "img/doctor-stethoscope.51fe72df.svg";